<template >
    <div class="popup-container">
        <div class="text-justify popup-wrapper">
            <div class="popup-header">
                <span>Alert</span> <i class="fa fa-times close-icon" @click="closePopup"></i>
            </div>
            <div class="popup-body">
                <p> Are you sure you want to skip? Selected image will not be uploaded!</p>
            </div>
            <div class="popup-footer">
                <!-- <button class="close-button" style = "alignItems:center" @click = "closePopup">Close</button> -->
                <button class="ob-button" style = "alignItems:center;float:right;" @click = "goForward">Ok</button>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    methods:{
        closePopup(){
            this.$emit('closePopup')
        },
        goForward(){
            this.$emit('goForward')
        }
    },
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        },
        orgEmail(){
            let title = this.$store.state.orgTitle
            return "support@" + title + ".com"
        },
        mailHref(){
            let title = this.$store.state.orgTitle
            return "mailto:support@" + title + ".com"
        }
    }
}
</script>

<style lang="scss" >
.terms-text{
    overflow-y: auto;
    max-height: calc(100vh - 300px);
}
</style>
